import { Component } from 'vue-property-decorator'
import storage from '@shared/storage'
import MixinAuthetication from '@mixins/authentication'
import { mixins } from 'vue-class-component'

@Component
export default class Lobby extends mixins(MixinAuthetication) {
  public username: string = ''

  public createUser() {
    if (this.username.length < 3) {
      return
    }

    if (this.username.length > 10) {
      this.$flits.info('Uw gebruikersnaam mag maximaal 10 karakers bevatten')
      return
    }

    this.$feathers.service('/api/players')
      .create({
        name: this.username,
      })
      .then(async (user) => {
        storage.setItem('userKey', user.key)
        this.$router.push('/tables')
      })
      .catch((err) => {
        throw err
      })
  }
}
